import setRouterPageLoading from 'ia-react-core/~/actions/router-fn/setRouterPageLoading';
import setRouterPageLoadingError from 'ia-react-core/~/actions/router-fn/setRouterPageLoadingError';
import setRouterPageLoaded from 'ia-react-core/~/actions/router-fn/setRouterPageLoaded';
import { RouterState } from 'ia-react-core/~/interfaces/RouterState';
import SetRouterPageLoaded from 'ia-react-core/~/actions/router/SetRouterPageLoaded';
import SetRouterPageLoading from 'ia-react-core/~/actions/router/SetRouterPageLoading';
import SetRouterPageLoadingError from 'ia-react-core/~/actions/router/SetRouterPageLoadingError';
import { RouterAction } from 'ia-react-core/~/interfaces/RouterAction';
import LocationChanged from 'ia-react-core/~/actions/router/LocationChanged';
import locationChanged from 'ia-react-core/~/actions/router-fn/locationChanged';
import { injectQuery } from './withRouter.utils';

const withRouterReducer = (state: RouterState, action: RouterAction): RouterState => {
  switch (action.type) {
    case setRouterPageLoading.type:
      return reduceSetRouterPageLoading(state, action as SetRouterPageLoading);
    case setRouterPageLoaded.type:
      return reduceSetRouterPageLoaded(state, action as SetRouterPageLoaded);
    case setRouterPageLoadingError.type:
      return reduceSetRouterPageLoadingError(state, action as SetRouterPageLoadingError);
    case locationChanged.type:
      return reduceLocationChanged(state, action as LocationChanged);
    default:
      return {
        loadingPage: null,
        ...state,
      };
  }
};

export default withRouterReducer;

const reduceSetRouterPageLoading = (state: RouterState, action: SetRouterPageLoading) => ({
  ...state,
  loadingPage: action.loadingPage,
});

const reduceSetRouterPageLoaded = (state: RouterState, action: SetRouterPageLoaded) => {
  if (state?.loadingPage === action.loadingPage) {
    return {
      ...state,
      loadingPage: null,
    };
  }
  return state;
};

const reduceSetRouterPageLoadingError = (state: RouterState, action: SetRouterPageLoadingError) => {
  if (state?.loadingPage === action.loadingPage) {
    return {
      ...state,
      loadingPage: null,
    };
  }
  return state;
};

const reduceLocationChanged = (state: RouterState, { location, action }: LocationChanged) => ({
  ...state,
  location: injectQuery(location as unknown as RouterState['location']),
  action,
}
);
